import React from 'react';

const AgendaExportEvent = ({oaUrl, oaLabel}) => (
	<p className="agenda-export-event"><a rel="noopener noreferrer" className="btn btn-primary btn-lg btn-pink-3" href={oaUrl} target="_blank">{oaLabel}</a></p>
)

export default AgendaExportEvent;
